import React from "react";
import Helmet from "react-helmet";
// helpers
import { IMAGE_URLS } from "../helpers/constants";
import { generateLinkForAllEvents, imageCacheLink } from "../helpers/linkGenerators";
const getMetadataForDisplayModeHelmet = (props) => {
    let ogImage;
    if (props.tabName === "") {
        ogImage = IMAGE_URLS.HELMET;
    }
    else {
        ogImage = imageCacheLink(IMAGE_URLS.HELMET, {
            y: 70,
            q: 100,
            f: "auto"
        });
    }
    const title = props.title === undefined ? "Handpicked & Awesome!" : props.title;
    const description = props.description === undefined ? "Handpicked & Awesome" : props.description;
    return [
        { name: "description", content: description },
        { name: "keywords", content: "food, movie, music, travel" },
        { property: "og:title", content: title },
        { property: "og:description", content: description },
        { property: "og:image", content: ogImage },
        { property: "og:image:width", content: "600" },
        { property: "og:image:height", content: "314" },
        { property: "twitter:card", content: "summary" },
        { property: "twitter:title", content: title },
        { property: "twitter:description", content: description },
        { property: "twitter:image", content: ogImage }
    ];
};
const InsiderHelmet = (props) => {
    var _a, _b;
    const canonicalLink = ((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.origin) && (props === null || props === void 0 ? void 0 : props.selectedCity)
        ? `${window.location.origin}${generateLinkForAllEvents(props.selectedCity)}/${encodeURIComponent((_b = props.tabName) === null || _b === void 0 ? void 0 : _b.replace(/\s/g, "-").toLowerCase())}`
        : "";
    return (<Helmet>
			<title>{props.title}</title>
			{canonicalLink && <link rel="canonical" href={canonicalLink}/>}
			{getMetadataForDisplayModeHelmet({
            displayMode: props.displayMode,
            tabName: props.tabName,
            title: props.title,
            description: props.description
        }).map((tag, i) => {
            return <meta {...tag} key={i}/>;
        })}
		</Helmet>);
};
export default InsiderHelmet;
